export { default as AuthPage } from "./AuthPage";
export { default as ContactPage } from "./ContactPage";
export { default as FaqPage } from "./FaqPage";
export { default as HomePage } from "./HomePage";
export { default as HowAlinWorksPage } from "./HowAlinWorksPage";
export { default as NotFoundPage } from "./NotFoundPage";
export { default as ThePlatformPage } from "./ThePlatformPage";
export { default as SingUp } from "./SingUp";
